import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Switch from '../../components/UI/Switch/Switch';
import { FaInfoCircle } from 'react-icons/fa';
import classes from './LocatePod.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import api from '../../axios-local-api';

  const LocatePod = (props) => {
    
      const [isLocatePodDisabled, setIsLocatePodDisabled] = useState(false);
      const { checkingWan, timerStart, rebootPodId, selectedEquipment, podTimer, firmware } = props; 
      const handleToggle = () => {
          props.handleLocatePod();
      } 
      const resetLocatePod = () => {
        props.locateAllPods();
      }

      const handleBeforeUnLoad = () => {
        resetLocatePod();
      }
      
      useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnLoad);
        window.addEventListener('unload', handleBeforeUnLoad);
        if (((checkingWan || (podTimer && rebootPodId === selectedEquipment.podId)) && timerStart)
        || (selectedEquipment.podConnectionState === 'disconnected')
        || (selectedEquipment && selectedEquipment.displayAllEquipment && firmware && firmware.upgradeRecommendedPostOnboarding)
        ) {
          setIsLocatePodDisabled(true);
        } else {
          setIsLocatePodDisabled(false);
        }

        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnLoad);
          window.removeEventListener('unload', handleBeforeUnLoad);
          // resseting the locatepod when component is unmount
          resetLocatePod();
          
        }
        
      }, [checkingWan, timerStart, podTimer, selectedEquipment, rebootPodId]);

      
      return (
          <Box>
            <div className={classes.LocatePod}>
              <div className={classes.TitleArea}>
              <h3> Locate Extender </h3>
              <div id = "ExclusionToggleLocatePod" className={[classes.desktop_view1, classes.switchclass, classes.mobile_view1].join(' ')}>
                <Switch
                  id={selectedEquipment.podId}
                  aria-checked={props.defaultLocatePod}
                  aria-label="Toggle LocatePod"
                  onChange={handleToggle} 
                  checked={props.defaultLocatePod}
                  disabled={isLocatePodDisabled}
                />
              </div>
              </div>
            <div id = 'LocatePodAlert' className={[classes.alertMessageContainer, classes.desktop_view1, classes.mobile_view1].join(' ')}>
                <span className={classes.desktop_view}><FaInfoCircle color="#38a9f9" size={24}/></span>
                <span className={classes.mobile_view}><FaInfoCircle color="#38a9f9" size={16}/></span>
                <span className={classes.alertMessage}>The Extender's LED light will turn on then blink for up to 20 min. </span>
            </div>
            </div>
          </Box>
        )
    }
  
  const mapStateToProps = (state => {
    return {
      checkingWan: state.wan.checkingWan,
      podTimer: state.wan.podTimer,
      rebootPodId: state.wan.rebootPodId,
      timerStart: state.wan.timerStart,
      selectedEquipment: state.equipment.selectedEquipment,
      firmware: state.settings.firmwareUpdate
    };
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {  
      locateAllPods: () => {dispatch(actions.locateAllPods())}
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(LocatePod, api));
  